import { render, staticRenderFns } from "./AdmissionsSearch.vue?vue&type=template&id=0bb95049&scoped=true&"
import script from "./AdmissionsSearch.vue?vue&type=script&lang=js&"
export * from "./AdmissionsSearch.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionsSearch.vue?vue&type=style&index=0&id=0bb95049&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb95049",
  null
  
)

export default component.exports